import { Role } from "./role";
export class ModuleGroupRole{
    moduleId: number;
    moduleName: string;
    childs: ModuleGroupRole = new ModuleGroupRole();
    roles: Role[] = [];
}